import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HistoryEventService } from '../services/history.event.service';
import { AccountService } from '../services/account';
import { Router } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';
import { environment } from '../../environments/environment';
import { LogService } from '../services/log.service';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule,
];

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [MODULES],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
})
export class ProfileComponent {
  public accountInfo: AccountInfo = {} as AccountInfo;
  public isDataLoaded: boolean = false;
  private changeDetectorRef = inject(ChangeDetectorRef);
  public avatarUrl: string = '';
  public isShowAvatar: boolean = false;
  private logService = inject(LogService);

  constructor(
    private historyEventService: HistoryEventService,
    private accountService: AccountService,
    private subscriptionService: SubscriptionService,
    private router: Router
  ) {
    this.historyEventService.getEvent().subscribe(event => {
      this.logService.LogMessage("Профиль. Получено событие " + event);
      if (event == 'account') {
        this.getAccount();
        this.getAccountAvatar();
      }
      if (event == 'subscription') {
        var status = subscriptionService.getSubscriptionStatus();
        this.isShowAvatar = status == 'active';
      }
    });
  }

  private getAccountAvatar() {
    var claim = localStorage.getItem("id_token_claims_obj");
    if (claim != null) {
      var claimJson = JSON.parse(claim);
      this.avatarUrl = claimJson.picture;
    }
  }

  private getAccount() {
    this.accountService.getApiAccountInfo()
      .subscribe(data => {
        this.logService.LogMessage("Профиль. Получена информация аккаунта");
        this.isDataLoaded = true;
        this.accountInfo = data;
        this.accountService.setAccountInfo(data);
        this.changeDetectorRef.markForCheck();
      });
  }

  public profileLogout() {
    if (environment.environment == "local") {
      this.accountService.logOut();
      this.router.navigate([""]);
    }
  }

}
